/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Link } from '@fluentui/react/lib/Link';
import React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { Dispatcher } from 'src/core/types/dispatcher';
import { GlobalHandlerGroup } from 'src/core/types/GlobalHandlerGroup';

const messages = defineMessages({
    copyFailed: { id: 'core.copyProjectToastData.copyFailed', defaultMessage: 'Copy failed' },
    copyCompleted: { id: 'core.copyProjectToastData.copyCompleted', defaultMessage: 'Copy completed' },
    switchToResource: { id: 'core.copyProjectToastData.switchToResource', defaultMessage: 'Switch to resource' },
    runningCopyDescription: {
        id: 'core.copyProjectToastData.runningCopyDescription',
        defaultMessage: 'Copying project {projectName} to resource {resourceName}.'
    },
    viewCopiedProject: { id: 'core.copyProjectToastData.viewCopiedProject', defaultMessage: 'to view your copied project' }
});

const makeSelectResourceModalVisible = (
    selectedResourceId: string,
    selectedSubscriptionId: string,
    dispatcher: Dispatcher<GlobalHandlerGroup>
) => {
    dispatcher.dispatch('updateCsAccountSelectModalProps', {
        isVisible: true,
        resourceId: selectedResourceId,
        subscriptionId: selectedSubscriptionId
    });
};

export const getCopyProjectToastData = ({
    localize,
    dispatcher,
    projectName,
    resourceName,
    selectedResourceId,
    selectedSubscriptionId
}: {
    projectName: string;
    resourceName: string;
    selectedResourceId: string;
    selectedSubscriptionId: string;
    dispatcher: Dispatcher<GlobalHandlerGroup>;
    localize: ReactIntl.InjectedIntl['formatMessage'];
}) => ({
    running: {
        isTitleTruncated: false,
        title: localize(messages.runningCopyDescription, {
            projectName,
            resourceName
        })
    },
    completed: {
        title: localize(messages.copyCompleted),
        content: (
            <LuisText>
                <LuisText>{localize(messages.switchToResource)}</LuisText>
                <Link
                    styles={{ root: { paddingLeft: 2, paddingRight: 2 } }}
                    onClick={() => {
                        makeSelectResourceModalVisible(selectedResourceId, selectedSubscriptionId, dispatcher);
                    }}>
                    {resourceName}
                </Link>
                <LuisText>{localize(messages.viewCopiedProject)}</LuisText>
            </LuisText>
        )
    },
    failed: {
        title: localize(messages.copyFailed)
    }
});
